import { LockedChannelPopup } from 'common/components/keyboard-popups';
import { usePopup } from 'common/contexts/popup';
import { isEmpty } from 'lodash';
import React, { useCallback } from 'react';

const PIN_POPUP_ID = 'locked-channel-popup';

interface OpenPinPopupOptions {
  onSuccess: VoidFunction;
  title?: string;
}

export const usePinPopup = () => {
  const { openPopup, closePopup, getPopup } = usePopup();

  const openPinPopup = useCallback(({ onSuccess, title }: OpenPinPopupOptions) => {
    openPopup({
      id: PIN_POPUP_ID,
      type: 'primary',
      preventBackspace: true,
      content: (
        <LockedChannelPopup popupId="locked-channel-popup" onSuccess={onSuccess} title={title} />
      )
    });
  }, []);

  const closePinPopup = useCallback(() => {
    closePopup(PIN_POPUP_ID);
  }, []);

  const checkOpened = useCallback(() => {
    return !isEmpty(getPopup(PIN_POPUP_ID));
  }, []);

  return {
    openPinPopup,
    closePinPopup,
    checkOpened
  };
};
